import { isNil } from "lodash";
import { useTranslation } from "react-i18next";
import { buildGoogleStreetViewUrl } from "common-client/utils/useStreetViewImage";
import { Button } from "../Buttons/Button";

export const ViewOnStreetViewButton = ({
  latitude,
  longitude,
}: {
  latitude?: Maybe<number>;
  longitude?: Maybe<number>;
}) => {
  const { t } = useTranslation();
  const streetViewLink =
    !isNil(latitude) && !isNil(longitude)
      ? buildGoogleStreetViewUrl(latitude, longitude)
      : null;

  return streetViewLink ? (
    <Button
      variant="secondary"
      size="small"
      title={t("button-google-streetview")}
      onPress={() => window.open(streetViewLink, "_blank")}
      data-testid="streetview-link"
    />
  ) : null;
};
